var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav-app-bar'),_c('nav-app-drawer'),_c('v-main',{staticStyle:{"background":"#eee"}},[_c('show-info'),_c('confirm-dialog',{ref:"confirm"}),_c('div',[_c('router-view')],1),_c('portal-target',{attrs:{"name":"v-main","multiple":""}})],1),_c('confirm-dialog',{ref:"confirmDialogGlobal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }